























































































import ThgCheckoutSustainableCard from "@/components/thg/ThgCheckoutSustainableCard.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ThgVehicleTypes } from "@/store/enum/thg/thg-vehicle-types.enum";
import { GtagModule } from "@/store/modules/gtag.store";
import { PartnerActiveOfferModule } from "@/store/modules/partner-active-config.store";
import { ReportModule } from "@/store/modules/report.store";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component } from "vue-property-decorator";
import ThgProductsPriceCard from "./ThgProductsPriceCard.vue";
import ThgProductsPriceComboCard from "./ThgProductsPriceComboCard.vue";

@Component({
  components: {
    LayoutReportStep,
    ThgCheckoutSustainableCard,
    ThgProductsPriceCard,
    ThgProductsPriceComboCard
  }
})
export default class ThgCombiDeal extends ReportStepMixin implements IReportStep {
  screen = ReportScreenEnum.thgCombiDeal;

  isLoading = false;

  CurrencyEnum = CurrencyEnum;

  get cardTitle(): string {
    const years =
      this.combiDeal?.prices
        ?.map(p => p.year)
        .filter((y, i, arr) => arr.indexOf(y) === i) // Duplikate entfernen
        .sort((a, b) => a - b) || [];

    const yearsText =
      years.length === 1 ? `${years[0]}` : years.length === 2 ? `${years[0]} & ${years[1]}` : years.join(", ");

    const hasPromo = this.activePromotion && this.activePromotion.isApplicable;

    return `Kombiprämie für ${yearsText}${hasPromo ? " (inkl. Neukundenbonus)" : ""}`;
  }

  get activePromotion() {
    return PartnerActiveOfferModule.currentSignUpPromotion;
  }

  get years() {
    return ThgCreateModule.years;
  }

  set years(years: number[]) {
    ThgCreateModule.setYears(years);
  }

  get showTotalAmount() {
    for (const price of this.combiDeal?.prices || []) {
      if (!price.totalAmount) {
        return false;
      }
    }
    return true;
  }

  get totalAmount() {
    let price =
      this.combiDeal?.prices.reduce((acc, price) => {
        return acc + (price.totalAmount || 0);
      }, 0) || 0;

    if (this.activePromotion && this.activePromotion.value && this.activePromotion.isApplicable) {
      price = price + this.activePromotion.value;
    }

    return price;
  }

  get header(): IReportHeaderData {
    const hasPromo = this.activePromotion && this.activePromotion.isApplicable;

    return {
      title: hasPromo ? "report.thgCombiDeal.titleWithPromotion" : "report.thgCombiDeal.titleWithoutPromotion",
      description: hasPromo
        ? "report.thgCombiDeal.descriptionWithPromotion"
        : "report.thgCombiDeal.descriptionWithoutPromotion"
    };
  }

  get instruction(): IReportInstructionData {
    const hasPromo = this.activePromotion && this.activePromotion.isApplicable;

    return {
      title: this.header.title,
      text: hasPromo
        ? "report.thgCombiDeal.descriptionLongWithPromotion"
        : "report.thgCombiDeal.descriptionLongWithoutPromotion",
      pictures: [AssetEnum.charging],
      example: AssetEnum.charging,
      display: false
    };
  }

  get combiDeal() {
    return PartnerActiveOfferModule.priceConfig.getCombiDeal(ThgVehicleTypes.M1);
  }

  get company() {
    return ReportModule.partner.companyName;
  }

  get color() {
    return getDefaultPartnerColor();
  }

  get isDone() {
    return this.years.length >= 2 && !this.isLoading;
  }

  async fetchPrices() {
    try {
      this.isLoading = true;
      await PartnerActiveOfferModule.loadDocuments(ReportModule.partner.id);

      if (!this.years.length && this.combiDeal) {
        this.years = this.combiDeal.years;
      }
    } catch (error) {
      this.$log.error(error);
      this.$toast.error(this.$t("report.thgProducts.loadingError"));
    }

    this.isLoading = false;
  }

  next() {
    GtagModule.dispatchViewItemEvent();
  }

  async mounted() {
    this.setCurrentStep();
    await this.fetchPrices();
  }
}
